import {
  styled,
  Tooltip,
  tooltipClasses,
  TooltipProps,
  Zoom,
} from '@mui/material'

export const AdvancedTooltip = styled(
  ({ className, ...props }: TooltipProps) => (
    <Tooltip
      {...props}
      TransitionComponent={Zoom}
      classes={{ popper: className }}
    />
  ),
)(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: 'white',
    maxWidth: '30vw',
    boxShadow: '0px 2px 10px 0px rgba(0, 0, 0, 0.1)',
    padding: 0,
    margin: 0,
  },
}))
